import {useEffect} from "react";
import {useGenres} from "../../hooks/UseGenres";
import {EmptyGenre} from "./EmptyGenre";
import {Genre} from "./Genre";
import {useNavigate} from "react-router-dom";

export function GenresPanel(props) {
    const user = props.user;
    const genreHook = useGenres();
    const genres = genreHook.genres;

    const navigate = useNavigate();

    const onBackClicked = () => {
        navigate('/');
    }

    const onCreateClicked = async (genre) => {
        await genreHook.createGenre(user.token, genre);
    }
    const onDeleteClicked = async (genre) => {
        const confirmed = window.confirm(`Ви впевнені, що хочете видалити жанр "${genre.name}"?`);
        if (confirmed) {
            await genreHook.deleteGenre(user.token, genre);
        }
    }

    useEffect(() => {
        genreHook.loadGenres(user.token);
    }, [user]);

    const genresElements = genres
        ?.slice() // Create a shallow copy to avoid mutating the original state
        .sort((a, b) => a.name.localeCompare(b.name)) // Sort alphabetically by name
        .map(g => <Genre genre={g} key={g.id} onDeleteClicked={onDeleteClicked}/>);

    return (
        genres ?
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '20px',
                paddingLeft: '15px',
                paddingRight: '15px'
            }}>
                <button
                    onClick={onBackClicked}
                    style={{
                        marginBottom: '20px',
                        padding: '8px 20px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        fontWeight: '600',
                        color: '#374151',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        transition: '0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                >
                    ← Назад
                </button>

                <h2 style={{ margin: '0 0 20px 0', fontSize: '28px', color: '#111827' }}>Жанри</h2>

                <EmptyGenre onCreateClicked={onCreateClicked}/>

                <div style={{ marginTop: '20px' }}>
                    {genresElements}
                </div>
            </div>
            :
            <div>loading</div>
    );
}